/* eslint-disable */
const navigation = {  
    namespaced:true,    

    state: {
       routeName:'',
       selectedIndex:'',
       selectedSubIndex:'',
    },

    actions: {
      GET_ROUTE: ({ commit }, url) => {
          commit('SET_ROUTE', url)
          console.log('response => route',url)
      },

      GET_INDEX: ({ commit }, index) => {
        commit('SET_INDEX', index)
        console.log('response => index selected',index)
      },

      GET_SUB_INDEX: ({ commit }, subindex) => {
        commit('SET_SUB_INDEX', subindex)
        console.log('response => subindex',subindex)
      }
    },

    mutations: {

      SET_ROUTE: (state,url) => {
          state.routeName = url;
      },

      SET_INDEX: (state,index) => {
        state.selectedIndex = index;
      },

      SET_SUB_INDEX: (state,subindex) => {
        state.selectedSubIndex = subindex;
      }
    }
}

export default navigation